import { render, staticRenderFns } from "./ObjectManager.vue?vue&type=template&id=4f38d494&"
import script from "./ObjectManager.vue?vue&type=script&lang=js&"
export * from "./ObjectManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports